import { useQuery } from '@tanstack/react-query';
import qs from 'qs';
import type { AgentApiDashboardsProgress } from '@/types/serializers';
import { fetchJson } from '@/utils/apiFetch';

/**
 * ダッシュボード進捗状況（current_progress 別件数のスナップショット）を取得するフック。
 * `organizationUserId` を渡すと担当者で絞り込む。
 */
export default function useFetchDashboardProgress(organizationUserId?: string) {
  const query = qs.stringify(
    organizationUserId ? { organization_user_id: organizationUserId } : {},
    { arrayFormat: 'brackets' }
  );
  return useQuery({
    queryKey: ['dashboard-progress', query],
    queryFn: async () => {
      const data = await fetchJson<AgentApiDashboardsProgress>(
        `/agent/api/dashboard/progress.json?${query}`
      );
      return data;
    },
  });
}
